export const firebaseConfig = {
	apiKey: "AIzaSyCSNfJVcgfQrq9oVDzzclKbgFYloVxwPK0",
	authDomain: "asquire-mox.firebaseapp.com",
	projectId: "asquire-mox",
	storageBucket: "asquire-mox.appspot.com",
	messagingSenderId: "1057786994828",
	appId: "1:1057786994828:web:0b7c36c7d01b93d72b9ba9",
	measurementId: "G-RR2BVRP73M",
};
